/**
 * Vite/React Router version of ProductCard.
 * Replaces next/image → <img> and next/link → react-router Link.
 */

import { Link } from 'react-router'
import type { Product } from '@/lib/types'

function formatPrice(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`
}

export function ProductCard({ product }: { product: Product }) {
  // Grid cards render at ~300px — prefer the 512px WebP thumb when present.
  const heroImg = product.images?.[0]?.thumbUrl ?? product.images?.[0]?.url ?? null
  return (
    <Link
      to={`/product/${product.slug}`}
      className="group block rounded-xl border border-white/8 bg-navy/40 hover:border-gold/40 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/40 transition-all duration-200 overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold"
    >
      <div className="relative aspect-square bg-[#111826] flex items-center justify-center overflow-hidden p-5">
        {heroImg ? (
          <img
            src={heroImg}
            alt={product.images[0]?.alt || product.name}
            width={512}
            height={512}
            className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div className="text-white/25 text-xs font-medium" aria-hidden="true">
            Image coming soon
          </div>
        )}
      </div>
      <div className="p-4 border-t border-white/5">
        <h3 className="text-sm font-semibold text-white leading-snug line-clamp-2">{product.name}</h3>
        <p className="text-gold-text font-bold mt-2 text-base">{formatPrice(product.price_cents)}</p>
      </div>
    </Link>
  )
}
